<template>
	<div class="header-component">
		<div class="logo-box">
			<div class="logo-img"><img src="../assets/images/logo.png" alt=""></div>
			<div class="logo-text">
				<p class="logo-text-title">{{title}}</p>
				<p class="logo-text-desc">{{desc}}</p>
			</div>
		</div>
		<div class="user-info-box">
			<img src="../assets/images/icon_user.png">
			<span>{{name}}</span>
			<div class="user-tips">
				<div>
					<!-- <div class="per-ico"></div>
					<div class="nav-user-info">
						<p>{{$store.state.username}}</p>
					</div> -->
				</div>
				<div class="nav-user-opr">
					<span @click="stSignout">退出登录</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	name: 'HeaderComponent',
	props: [],
	components: {},
	data() {
		return {
			title: '后台管理系统',
			desc: 'Logistics management system',
			userName: ''
		}
	},
	computed: {
		...mapGetters([
			'name',
		]),	
	},
	created() {},
	methods: {
		stSignout(){
			this.$store.dispatch('user/logout').then(res => {
				console.log('退出成功')
				this.$router.push('/login')
			})
		}
	},
	mounted() {
		this.userName = sessionStorage.getItem('username')
	}
}

</script>
<style scoped>
.header-component {
  width: 100%;
  height: 40px;
  background: #333;
  padding: 10px 0;
}


.logo-box {
  float: left;
  width: 620px;
  height: 40px;
  margin: 0 0 0 120px;
}

.logo-img {
  float: left;
  width: 120px;
  height: 40px;
  position: relative;
}

.logo-img::after {
  display: block;
  width: 1px;
  height: 40px;
  content: "";
  background: rgba(255, 255, 255, .4);
  position: absolute;
  right: -20px;
  top: 0;
}

.logo-img img {
  display: block;
  width: 100%;
}

.logo-text {
  float: left;
  width: 450px;
  height: 40px;
  margin: 0 0 0 40px;
}

.logo-text-title {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}

.logo-text-desc {
  display: block;
  width: 100%;
  height: 10px;
  line-height: 10px;
  color: #8C8C8C;
  font-size: 14px;
}

.user-info-box {
  /* float: right; */
  
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 10px;
  height: 60px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.user-info-box img {
  display: block;
  width: 20px;
  height: 20px;
  margin: 20px;
}
.user-info-box:hover .user-tips{
	display: block;

}
.user-tips{
	font-size: 14px;
	display: none;
	position: absolute;
	z-index: 99;
	right: 0;
	top: 60px;
	background-color:#fff;
	border: 1px solid #D8D8D8;
}
.per-ico{
	position: absolute;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	border: 1px solid #ccc;
	left: 10px;
	top: 10px;
}
.nav-user-info{
	padding-left: 70px;
	height: 70px;
	width: 100px;

}
.nav-user-info p{
	line-height: 70px;
	height: 70px;
	
}
.nav-user-opr{
	min-width: 100px;
	height: 30px;
	display: flex;
	justify-content: space-between;

}
.nav-user-opr span{
	width: 100%;
	height: 30px;
	line-height: 30px;
	text-align: center;
	background-color: #FF5B3E;
	color: #fff;

}
</style>
